module.exports = __webpack_public_path__ + "static/media/P1010688-e1467906501291-1024x979.1d192cbf.jpg";